<div class="form-columns">
    <div class="form-columns__inner {{align ? '-align-'+align : '-align-space-between'}}"
        [ngClass]="{'-items-margin': itemsMargin, '-mobile-full': mobileFull}">
        <ng-content></ng-content>
    </div>
</div>
